import React from 'react';
import styled from 'styled-components';

const HeroStyle = styled.div`
	background-image: linear-gradient(
			to left,
			rgba(0, 0, 0, 0.54),
			rgba(0, 0, 0, 0.54)
		),
		url(${(p) => p.bimg});
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 29rem;

	.rocks {
		width: 300px;
		margin-bottom: 1rem;
	}
`;
export default ({ data }) => {
	const { bimg, logo1, logo2 } = data;

	return (
		<HeroStyle bimg={bimg} className="hero">
			<img className="rocks" src={logo1.src} alt={logo1.alt} />
			<img src={logo2.src} alt={logo2.alt} />
		</HeroStyle>
	);
};
